export default {
  // Max-width is defined via className per case
  mobilingo: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray_900 bg-opacity-20",
    container:
      "bg-paper w-full max-h-full md:max-h-[calc(100vh-4rem)] rounded-[50px] custom-scrollbar overflow-y-scroll py-[20px] pl-[20px] pr-[12px]",// custom-scrollbar width = 8px, hence the different pl and pr.
    header: "relative w-full flex justify-between items-center py-5 mx-auto",
    closeButton: "absolute w-[34px] h-[34px] flex items-center justify-center right-5 top-5 bg-gray_200 rounded-full z-10",
    closeIcon: "h-[22px] w-[22px] text-gray_700 hover:text-gray_900 stroke-[2.5px]",
    title: "text-[22px] sm:text-[24px] md:text-[26px] xl:text-[28px] leading-tight text-text flex-1 text-center font-bold my-0",
    headerContent: "w-full flex items-center",
    contentWrapper: "w-full",
    content: "w-full",
  },

  mobilingo_big: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray_900 bg-opacity-20",
    container:
      "w-full md:w-[670px] h-full md:h-auto md:max-h-[calc(100vh-2rem)] bg-paper overflow-hidden md:rounded-[50px] pt-8 md:pt-12 pb-4 md:pb-8",
    header: "relative flex justify-between items-center px-11 mb-8", // Set px-11 for consistent padding with content section
    closeButton: "absolute flex items-center justify-center w-[34px] h-[34px] right-6 md:right-12 top-0 md:top-1 bg-gray_200 rounded-full z-10",
    closeIcon: "h-[22px] w-[22px] text-gray_700 hover:text-gray_900 stroke-[2.5px]",
    title:
      "text-[22px] sm:text-[24px] md:text-[26px] xl:text-[28px] leading-tight text-text flex-1 text-center font-bold my-0",
    headerContent: "flex items-center",
    contentWrapper:
      "w-full max-h-[calc(100vh-10rem)] overflow-y-auto px-6",
    content: "w-full md:py-4",
  },

  //Used for Success, MagicLink, Provider, etc.
  mobilingo_medium: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray_900 bg-opacity-20",
    container:
      "w-full md:w-[534px] h-full md:h-auto md:max-h-[calc(100vh-2rem)] bg-paper overflow-hidden md:rounded-[50px] py-8",
    header: "relative flex justify-between items-center px-10 mb-0",
    closeButton: "absolute w-[34px] h-[34px] flex items-center justify-center right-6 md:right-8 top-1 bg-gray_200 rounded-full z-10",
    closeIcon: "h-[22px] w-[22px] text-gray_700 hover:text-gray_900 stroke-[2.5px]",
    title:
      "text-[22px] sm:text-[24px] md:text-[26px] xl:text-[28px] font-bold text-text leading-tight my-0",
    headerContent: "flex items-center",
    contentWrapper:
      "w-full max-h-[calc(100vh-10rem)] overflow-y-auto px-4", 
    content: "w-full md:px-6 md:py-4",
  }
}
